import { IGachNoRequest } from "../../model/request/dong-bo/IGachNoRequest";
import { apiClient } from "../apiClient";

export const DONG_BO_ENDPOINT = "ngan-hang";

export const gachNoThuCongApi = {
  GachNoThuCong: (request: IGachNoRequest) =>
    apiClient.post(`${DONG_BO_ENDPOINT}/gach-no`, request),
};
